export default {
      id: "question-circle-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.svg#question-circle",
      toString: function () {
        return this.url;
      }
    }